import React from 'react';
import { withRouter } from 'react-router-dom';
import { components } from '@peachjar/components';
import { styles } from './IntroduceParentsTab.css';
import { Mutation } from 'react-apollo';
import VISIT_DISTRICT_SETUP_TASK_MUTATION from "../../_shared/gql/visitDistrictSetupTask.mutation";

const {
  NumberedRow,
  LoadingIndicators: { Spinner },
} = components;
const { ButtonSecondarySmall, ButtonPrimaryLarge } = components.Buttons;

const CONFIRM_SETUP_ROUTE = '/onboarding/setup/confirm';

const onContinueClick = (markTaskVisited, variables) => () => {
  markTaskVisited({ variables });
};

const IntroduceParents = ({
  isParentIntroContinueDisabled,
  handleContinueDisable,
  history,
  onNotifyError,
  ncesDistrictId,
  isParentsSetupCompleted,
}) => (
  <div className={styles.wrapper}>
    <div className={styles.numberedRowWrapper}>
      <NumberedRow
        className="numberedRow"
        rowNumber={1}
        headerText="Send an Introduction Email to Your Parents"
      >
        <p>
          Download the introductory template to introduce Peachjar to your
          parents. Just copy our template and paste into the body of your email.{' '}
          <strong>
            You must include pj@peachjar.com in the send list when you email
            parents.
          </strong>
        </p>
        <ButtonSecondarySmall
          href="https://cdn-assets.peachjar.com/portal-app/onboarding/Parent+Communication+Template.docx"
          onClick={handleContinueDisable}
        >
          Download Template
        </ButtonSecondarySmall>
      </NumberedRow>
    </div>

    <Mutation
      mutation={VISIT_DISTRICT_SETUP_TASK_MUTATION}
      onCompleted={() => history.push(CONFIRM_SETUP_ROUTE)}
      onError={onNotifyError}
    >
      {(markTaskVisited, { loading, error, data = {} }) => {
        const variables = {
          input: {
            ncesDistrictId,
            taskName: 'parentsEmailed',
          },
        };

        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonPrimaryLarge
              id="continue-parentSetup"
              onClick={onContinueClick(markTaskVisited, variables)}
              disabled={
                isParentIntroContinueDisabled && !isParentsSetupCompleted
              }
            >
              {loading && <Spinner />}Continue
            </ButtonPrimaryLarge>
          </div>
        );
      }}
    </Mutation>
  </div>
);

export default withRouter(IntroduceParents);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/containers/IntroduceParentsTab.jsx